import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { GroupMember } from '@era/security-sdk';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PaneComponent } from '@rocksoft/cdk';

@Component({
  selector: 'era-security-list-user-items-ui',
  templateUrl: './list-user-items.component.html',
  styleUrls: ['./list-user-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, FaIconComponent],
})
export class ListUserItemsComponent {
  public readonly users = input<GroupMember[]>();
  public readonly isEditing = input<boolean>();
  public readonly deleteEvent = output<GroupMember>();

  delete(member: GroupMember) {
    this.deleteEvent.emit(member);
  }
}
